<script>

import { mapState } from 'vuex';
import "leaflet/dist/leaflet.css"

import {
  LTileLayer,
  LMap,
  LMarker,
  LTooltip,
} from "@vue-leaflet/vue-leaflet"

import Audio from '../../Utils/Audio'
import Snippet from './Snippet'
import Anchor from './Anchor'
import Inlay from './Inlay'

export default {

  components: {
    LTileLayer,
    LMap,
    LMarker,
    LTooltip,
    Audio,
    Anchor,
    Snippet,
    Inlay,
  },

  props: [
    'map',
  ],

  data() {
    return {

      selectedAnchor: null,
      selectedSnippet: null,
      selectedAudio: null,

      elapsed: 0,
      zoom: 10,
      newzoom: 10,
      tiles: true,

      mapOpts: {
        zoomSnap: 0,
        // zoomDelta: 0,
        zoomDelta: 0.25,
        maxZoom: 13,
        zoomAnimation: true,
        zoomAnimationThreshold: 50,
        markerZoomAnimation: true,
        inertia: true,
      },

      anchorOpts: {
        permanent: true,
        className: "anchorContainer",
        direction: "center",
        interactive: true
      },

      inlayDimensions: null,
      alignmentAnchors: [],

    }
  },
  computed: {
    ...mapState([
      'location',
      'snippets',
      'anchors',
    ]),
    ...mapState('access', [
      'visited',
      'interacted',
      'desiresInlay',
      'options'
    ]),
  },

  mounted() {

    if (!this.visited) {
      setTimeout(() => {
        this.desiresIntro = true
      }, 1000)
    }

  },

  methods: {

    handleZoom(e) {
      this.newzoom = e.target.getZoom()
    },
    handleReady() {
      Array
      .from(document.querySelectorAll('.leaflet-control-zoom a'))
      .forEach(z => z.classList.add('ui'))
      document.querySelector('.leaflet-container')
      .setAttribute('tabindex', -1 )
    },

    isVisible(snippet) {
      return this.selectedAnchor
       && snippet.anchor.slug == this.selectedAnchor.slug
       || this.options.showEverything.value
    },

    selectAnchor(anchor) {
      this.selectedAnchor = anchor
    },
    selectSnippet(snippet) {
      this.selectedSnippet = snippet
    },
    selectAudio(audio) {
      this.selectedAudio = audio
    },
    clearSelection() {
      this.selectAudio(null)
      this.selectSnippet(null)
      this.selectAnchor(null)
    },

    handleSnippetClick(snippet, audio) {
      if (!this.selectedAnchor) {
        this.selectAnchor(this.anchors.find(a => a.slug == snippet.anchor.slug))
      }
      if (
          this.selectedSnippet == snippet &&
          this.selectedAudio == audio
      ) {
        this.selectAudio(null)
        this.selectSnippet(null)
      } else {
        this.selectSnippet(snippet)
        this.selectAudio(audio)
      }
    },

    nextSnippet(desiresDelay) {

      const
        snippets       = this.selectedAnchor.snippets,
        currentSnippet = snippets.find(s => s.id == this.selectedSnippet.id),
        nextSnippet    = snippets[snippets.indexOf(currentSnippet) + 1],
        audios         = this.selectedSnippet.audios,
        currentAudio   = audios.find(a => a.title == this.selectedAudio.title),
        nextAudio      = audios[audios.indexOf(currentAudio) + 1]

      if (nextAudio) {
        setTimeout(() => {
          this.selectAudio(nextAudio)
        }, desiresDelay ? 2000 : 0)
      } else if (nextSnippet) {
        setTimeout(() => {
          this.selectSnippet(this.snippets.find(s => s.id == nextSnippet.id))
          this.selectAudio(this.snippets.find(s => s.id == nextSnippet.id).audios[0])
        }, desiresDelay ? 2000 : 0)
      } else {
        setTimeout(() => {
          this.clearSelection()
        }, desiresDelay ? 4000 : 0)
      }

    },

    prevSnippet(desiresDelay) {

      const
        snippets       = this.selectedAnchor.snippets,
        currentSnippet = snippets.find(s => s.id == this.selectedSnippet.id),
        prevSnippet    = snippets[snippets.indexOf(currentSnippet) - 1],
        audios         = this.selectedSnippet.audios,
        currentAudio   = audios.find(a => a.title == this.selectedAudio.title),
        prevAudio      = audios[audios.indexOf(currentAudio) - 1]

      if (prevAudio) {
        setTimeout(() => {
          this.selectAudio(prevAudio)
        }, desiresDelay ? 2000 : 0)
      } else if (prevSnippet) {
        setTimeout(() => {
          this.selectSnippet(this.snippets.find(s => s.id == prevSnippet.id))
          this.selectAudio(this.snippets.find(s => s.id == prevSnippet.id).audios[0])
        }, desiresDelay ? 2000 : 0)
      } else {
        setTimeout(() => {
          this.clearSelection()
        }, desiresDelay ? 4000 : 0)
      }

    },

    placeAlignmentAnchors(anchors) {
      this.alignmentAnchors = anchors
    },

    handleSeekEnd() {
      if (!this.options.showEverything.value) {
        for (let anchor of this.anchors) {
          const alignmentAnchor = this.alignmentAnchors.find(a => a.for == anchor.slug)
          if (alignmentAnchor) {
            if (this.isInVicinity(anchor, alignmentAnchor)) {
              console.log('SELECTED ANCHOR: ' + anchor.slug)
              this.selectAnchor(anchor)
            } else {
              if (this.selectedAnchor == anchor) {
                this.clearSelection()
              }
            }
          }
        }
      }
    },

    isInVicinity(anchor, alignmentAnchor) {
      const
        anchorComp = this.$refs[anchor.slug + 'Anchor'][0],
        anchorRect = anchorComp.$el.getBoundingClientRect(),
        alignmComp = this.$refs[alignmentAnchor.for + 'AlignmentAnchor'][0],
        alignmRect = alignmComp.getBoundingClientRect(),
        gap        = this.desiresInlay ? 40 : 60,
        diagonal   = Math.sqrt(
            ( anchorRect.left - alignmRect.left ) ** 2 +
            ( anchorRect.top  - alignmRect.top  ) ** 2
          )

      anchorComp.distance = diagonal
      return (
        anchorRect.left   > alignmRect.left   - gap &&
        anchorRect.left   < alignmRect.left   + gap &&
        anchorRect.top    > alignmRect.top    - gap &&
        anchorRect.top    < alignmRect.top    + gap &&
        anchorRect.width  > alignmRect.width  - gap &&
        anchorRect.width  < alignmRect.width  + gap &&
        anchorRect.height > alignmRect.height - gap &&
        anchorRect.height < alignmRect.height + gap
      )
    }


  },

}
</script>

<template>
  <div
    id="map"
    aria-label="The map quadrant"
    tabindex="0"
    :class="{ physical: !desiresInlay }"
  >
    <l-map
      :zoom="zoom"
      :center="[-20, 20]"
      :options="mapOpts"
      :zoomAnimation="true"
      ref="map"
      tabindex="-1"
      @zoom="handleZoom"
      @ready="handleReady"
      @zoomend="handleSeekEnd"
      @moveend="handleSeekEnd"
    >

      <l-tile-layer
        v-if="tiles"
        url="https://mw1.google.com/mw-planetary/sky/skytiles_v1/{x}_{y}_{z}.jpg"
        layer-type="base"
        :max-zoom="mapOpts.maxZoom"
        :zoom-offset="10"
        attribution="SDSS, DSS Consortium, NASA/ESA/STScI"
      />

      <l-marker
        v-for="anchor in anchors"
        :key="anchor.slug"
        :lat-lng="[anchor.y * -1 || 0, anchor.x || 0]"
      >
        <l-tooltip :options="anchorOpts">
          <Anchor
            :anchor="anchor"
            :playing="location == 'map' && interacted && options.sound.value "
            :ref="anchor.slug + 'Anchor'"
            :isSelected="anchor == selectedAnchor"
            :zoom="newzoom"
            :elapsed="elapsed"
          />
        </l-tooltip>
      </l-marker>
    </l-map>

    <transition name="fade">
    <Audio
      v-if="selectedSnippet"
      :audio="selectedAudio"
      @elapsed="elapsed = $event"
      @prev="prevSnippet()"
      @next="nextSnippet()"
      @ended="nextSnippet(true)"
    />
    </transition>

    <div class="alignmentAnchors">
      <div
        v-for="anchor in alignmentAnchors"
        :key="anchor.for"
        :ref="anchor.for + 'AlignmentAnchor'"
        class="alignmentAnchor"
        :style="{
          '--left'   : anchor.left + 'px',
          '--top'    : anchor.top + 'px',
          '--width'  : anchor.width + 'px',
          '--height' : anchor.height + 'px'
        }"
      >
      </div>
    </div>

    <div
      v-if="inlayDimensions"
      class="snippets"
    >
      <Snippet
        v-for="snippet in snippets"
        :key="snippet.slug"
        :snippet="snippet"
        :selectedAudio="selectedAudio"
        :inlayDimensions="inlayDimensions"
        :zoom="zoom"
        :elapsed="snippet == selectedSnippet && elapsed || 0"
        :isVisible="isVisible(snippet)"
        :isSelected="snippet == selectedSnippet"
        @selectAudio="handleSnippetClick(snippet, $event)"
      />
    </div>

    <Inlay
      v-if="anchors.length > 0"
      :inlay="map.inlay"
      :physical="!desiresInlay"
      :anchors="anchors"
      @createdAlignmentAnchors="placeAlignmentAnchors"
      @computedInlayDimensions="inlayDimensions = $event"
    />

  </div>
</template>

<style>

#map {
  height: 100%;
  width: 100%;
  /* background: url('../../../assets/back.png');
  background-repeat: repeat;
  background-size: 256px 256px; */
}

#map .leaflet-container {
  background: none;
  background: black;
}

#map .leaflet-container .leaflet-shadow-pane,
#map .leaflet-container .leaflet-marker-icon,
#map .leaflet-control-container .leaflet-bottom.leaflet-right .leaflet-control.leaflet-control-attribution {
  display: none;
}
#map .leaflet-control-container .leaflet-top.leaflet-left {
  margin: 45px;
}
#map .leaflet-control-container .leaflet-top.leaflet-left .leaflet-control-zoom {
  border: none;
}
#map .leaflet-container .leaflet-tile-pane {
  /* opacity: 0.8; */
  filter: grayscale(1);
}
#map .leaflet-control-container .ui {
  background: transparent;
  color: var(--back);
  font-family: 'Space Grotesk';
  font-size: calc(25pt * var(--sizeFactor));
  font-weight: normal;
  border: none;
  padding: 0.5em;
}
#map .leaflet-control-container .ui::before,
#map .leaflet-control-container .ui::after {
  opacity: 0.8;
}
#map .leaflet-control-container .ui:nth-of-type(1) {
  margin-left: 1em;
}
#map .leaflet-control-container .ui:hover {
  z-index: 1;
}


/* #map .snippetContainer, */
#map .anchorContainer {
  background: none;
  border: none;
  box-shadow: none;
  color: var(--copy);
  min-width: 10em;
  min-height: 10em;
  max-width: 20em;
  max-height: 20em;
  opacity: 1;
}
/* #map .snippetContainer::before {
  display: none;
} */

.snippets {
  position: absolute;
  top: 0%;
  left: 0%;
  /* pointer-events: none; */
  z-index: 500;
}

#map .alignmentAnchors {
  box-sizing: border-box;
  position: absolute;
  pointer-events: none;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 5000;
}

#map .alignmentAnchors .alignmentAnchor {
  position: absolute;
  padding: 0;
  width: var(--width);
  height: var(--height);
  left: var(--left);
  top: var(--top);
  /* opacity: 0.2; */
  /* background: white; */
  margin: 0;
}

.isMobile #map .leaflet-control-container .leaflet-top.leaflet-left {
  margin: 1em;
}
.isMobile #map .leaflet-control-container .ui {
  font-size: calc(20pt * var(--sizeFactor));
  font-weight: normal;
  border: none;
  padding: 0.2em;
}

</style>
